<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'MatchingProfileDataProvider',
  created() {
    this.fetchItems();
  },
  methods: {
    ...mapActions('MatchingProfile', ['fetchItems', 'refresh', 'saveProfile'])
  },
  computed: {
    ...mapGetters('MatchingProfile', [
      'getProfile',
      'isLoading',
      'failed',
      'isComplete'
    ])
  },
  render() {
    return this.$scopedSlots.default({
      profile: this.getProfile,
      isComplete: this.isComplete,
      loading: this.isLoading,
      failed: this.failed,
      refresh: this.refresh,
      saveProfile: this.saveProfile
    });
  }
};
</script>
